import { Component, Input, OnChanges, OnInit } from '@angular/core';
import Chart from 'chart.js';
import { SessionData, SessionDataService } from '../../service/session-data.service';
import { SpinnerService } from '../../../spinner-component/spinner.service';

@Component({
  selector: 'app-session-graph',
  templateUrl: './session-graph.component.html',
  styleUrls: ['../../user-behaviour.component.css']
,
  standalone: false
})
export class SessionGraphComponent implements OnChanges {
  @Input() selectedTab: any;
  timeRange: string = 'month'; 
  chart: Chart;
  sessionData: SessionData[] = [];
  private isInitialLoad: boolean = true;
  startDate: Date | null = null;
  endDate: Date | null = null;
  loading =  true;

  constructor(private sessionDataService: SessionDataService,     
    public spinner: SpinnerService,
  ) {}

  ngOnInit(): void {
    // console.log("...", this.selectedTab);
    if (this.isInitialLoad && this.selectedTab == '0') {
      console.log("**ngOnInit session graph")
      this.applyFilter();
        //this.updateGraph();
    }
  }

  applyFilter(): void {
    let fromDate: string;
    let toDate: string;
    const currentDate = new Date();
  
    if (this.timeRange === 'day') {
      fromDate = this.formatDateToLocal(currentDate, '00:00:00');
      toDate = this.formatDateToLocal(currentDate, '23:59:59');
    } else if (this.timeRange === 'week') {
      const startOfWeek = new Date(currentDate);
      startOfWeek.setDate(currentDate.getDate() - currentDate.getDay());
      fromDate = this.formatDateToLocal(startOfWeek, '00:00:00');
      toDate = this.formatDateToLocal(currentDate, '23:59:59');
    } else if (this.timeRange === 'month') {
      const startOfMonth = new Date(currentDate.getFullYear(), currentDate.getMonth(), 1);
      fromDate = this.formatDateToLocal(startOfMonth, '00:00:00');
      toDate = this.formatDateToLocal(currentDate, '23:59:59');
    } else if (this.timeRange === 'custom' && this.startDate && this.endDate) {
      fromDate = this.customFormatDate(this.startDate);
      toDate = this.customFormatDate(this.endDate);
    } 
    // else {
    //   // fromDate = this.formatDateToLocal(currentDate, '00:00:00');
    //   // toDate = this.formatDateToLocal(currentDate, '23:59:59');
    //   // fromDate = this.formatDate(currentDate);
    //   // toDate = this.formatEndDate(currentDate);
    // }
    if (fromDate && toDate) {
      this.updateGraphs(fromDate, toDate);
    }
  }

  customFormatDate(momentDate: any): string {
    const formattedDate =  momentDate.format('YYYY-MM-DD HH:mm:ss');
    return formattedDate;
  }

  formatDate(date: Date): string {
    const localDateString = date.toLocaleDateString('en-US');
    return localDateString.split('T')[0] + ' 00:00:00';
  }

  formatDateToLocal(date: Date, prefix: string): string {
    const localDate = new Date(date.getTime());
    const year = localDate.getFullYear();
    const month = String(localDate.getMonth() + 1).padStart(2, '0');
    const day = String(localDate.getDate()).padStart(2, '0');
  
    const formattedDate = `${year}-${month}-${day} ${prefix}`;
  
    return formattedDate;
  }

  formatEndDate(date: Date): string {
    return date.toISOString().split('T')[0] + ' 23:59:59';
  }

  ngOnChanges(changes: any): void {
    if (!changes.selectedTab || String(changes.selectedTab.currentValue) !== '0') {
      return;
    }

    const previousTab = changes.selectedTab.previousValue;
    if (previousTab !== undefined && previousTab !== null && String(previousTab) !== '0') {
      this.resetDashboardFilters();
    }

    this.loading = true;
    this.applyFilter();
    this.isInitialLoad = false;
  }

  resetDashboardFilters(): void {
    this.timeRange = 'month';
    this.startDate = null;
    this.endDate = null;
  }

  ngAfterViewInit() {
    // if (this.selectedTab == '0') {
    //     this.sessionDataService.getSessions().subscribe(sessionData => {
    //         this.sessionData = sessionData;
    //         this.filterAndCreateChart();
    //     });        
    // }
  }

  onCustomDateChange() {
    if (this.timeRange === 'custom' && this.startDate && this.endDate) {
      this.applyFilter();
    }
  }
  updateGraphs(fromDate: string, toDate: string) {
    const payload = {
      fromDate: fromDate,
      toDate: toDate,
    };
    this.spinner.activate();
    this.sessionDataService.getHistoryGraphMetrics(payload).subscribe(data => {
      setTimeout(() => {
        this.loading = false;
        this.drawChart(data);
      });
      this.spinner.deactivate();
    });
  }

  drawChart(sessionData: any) {
    const groupedByDateAndSource = sessionData?.groupedData;
    //this.groupByDateAndSource(sessionData);
    const dates = sessionData?.dates; //this.getDatesForTimeRange(groupedByDateAndSource);

    const sources = sessionData?.sources;//Array.from(new Set(sessionData.map(session => session.source)));

    //console.log("groupedByDateAndSource>>", {dates,sources, groupedByDateAndSource})

    const datasets = sources.map((source, index) => {
      const data = dates.map(date => {
        return groupedByDateAndSource[date]?.[source] || 0;
      });
      
      return {
        label: source,
        data: data,
        borderColor: this.getColor(index),
        fill: false
      };
    });

    if (this.chart) {
      this.chart.destroy();
    }

    const ctx = document.getElementById('loginFrequencyChart') as HTMLCanvasElement;
    this.chart = new Chart(ctx, {
      type: 'line',
      data: {
        labels: dates,
        datasets: datasets
      },
      options: {
        scales: {
          xAxes: [{
            ticks: {
              beginAtZero: true
            }
          }],
          yAxes: [{
            ticks: {
              beginAtZero: true
            }
          }]
        }
      }
    });
  }

  createLoginFrequencyChart(sessionData: SessionData[]) {
    const groupedByDateAndSource = this.groupByDateAndSource(sessionData);
    const dates = this.getDatesForTimeRange(groupedByDateAndSource);

    const sources = Array.from(new Set(sessionData.map(session => session.source)));

    //console.log("groupedByDateAndSource>>", {dates,sources, groupedByDateAndSource})

    const datasets = sources.map((source, index) => {
      const data = dates.map(date => groupedByDateAndSource[date][source] || 0);
      
      return {
        label: source,
        data: data,
        borderColor: this.getColor(index),
        fill: false
      };
    });

    if (this.chart) {
      this.chart.destroy();
    }

    const ctx = document.getElementById('loginFrequencyChart') as HTMLCanvasElement;
    this.chart = new Chart(ctx, {
      type: 'line',
      data: {
        labels: dates,
        datasets: datasets
      },
      options: {
        scales: {
          xAxes: [{
            ticks: {
              beginAtZero: true
            }
          }],
          yAxes: [{
            ticks: {
              beginAtZero: true
            }
          }]
        }
      }
    });
  }

  filterSessionsByDay(data: SessionData[]): SessionData[] {
    const today = new Date().toISOString().split('T')[0];
    return data.filter(session => session.loginTimeInIST.split(' ')[0] === today);
  }

  filterSessionsByWeek(data: SessionData[]): SessionData[] {
    const currentDate = new Date();
    const startOfWeek = new Date(currentDate.getFullYear(), currentDate.getMonth(), currentDate.getDate() - currentDate.getDay());
    const endOfWeek = new Date(currentDate.getFullYear(), currentDate.getMonth(), currentDate.getDate() + (6 - currentDate.getDay()));

    return data.filter(session => {
      const sessionDate = new Date(session.loginTimeInIST.split(' ')[0]);
      return sessionDate >= startOfWeek && sessionDate <= endOfWeek;
    });
  }

  filterSessionsByMonth(data: any): SessionData[] {
    const currentDate = new Date();
    const startOfMonth = new Date(currentDate.getFullYear(), currentDate.getMonth(), 1);
    const endOfMonth = new Date(currentDate.getFullYear(), currentDate.getMonth() + 1, 0);

    return data.content.filter(session => {
      const sessionDate = new Date(session.loginTimeInIST.split(' ')[0]);
      return sessionDate >= startOfMonth && sessionDate <= endOfMonth;
    });
  }

  getDatesForTimeRange(groupedByDateAndSource: { [date: string]: { [source: string]: number } }): string[] {
    const dates = Object.keys(groupedByDateAndSource).sort();
    switch (this.timeRange) {
      case 'day':
        return dates;
      case 'week':
        return this.getWeekDates(dates);
      case 'month':
        return this.getMonthDates(dates);
      default:
        return dates;
    }
  }

  getWeekDates(dates: string[]): string[] {
    return dates;
  }

  getMonthDates(dates: string[]): string[] {
    return dates; // Placeholder, implement actual logic
  }

  onTimeRangeChange(event?: { value: string }) {
    if (event?.value) {
      this.timeRange = event.value;
    }
    if (this.timeRange !== 'custom') {
      this.applyFilter();
    }
  }

  groupByDateAndSource(sessionData: SessionData[]): { [date: string]: { [source: string]: number } } {
    return sessionData.reduce((acc, session) => {
      const date = session.loginTimeInIST.split(' ')[0];
      if (!acc[date]) {
        acc[date] = {};
      }
      if (!acc[date][session?.source]) {
        acc[date][session.source] = 0;
      }
      acc[date][session.source]++;
      return acc;
    }, {});
  }

  getColor(index: number): string {
    const colors = ['rgba(75, 192, 192, 1)', 'rgba(255, 99, 132, 1)', 'rgba(54, 162, 235, 1)', 'rgba(255, 206, 86, 1)', 'rgba(153, 102, 255, 1)'];
    return colors[index % colors.length];
  }
}
